import { render, staticRenderFns } from "./BookingItemsList.vue?vue&type=template&id=2456dfb5&scoped=true"
import script from "./BookingItemsList.vue?vue&type=script&lang=js"
export * from "./BookingItemsList.vue?vue&type=script&lang=js"
import style0 from "./BookingItemsList.vue?vue&type=style&index=0&id=2456dfb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456dfb5",
  null
  
)

export default component.exports